import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import revenueService from '../../services/revenueService';

// ─── Async Thunks ─────────────────────────────────────────────────────────────

export const fetchRevenueReport = createAsyncThunk(
  'revenue/fetchReport',
  async (params, { rejectWithValue }) => {
    try {
      const response = await revenueService.getRevenueReport(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load revenue report');
    }
  }
);

// ─── Initial State ────────────────────────────────────────────────────────────

const initialState = {
  report: null,
  aircraft: [],
  meta: null,
  loading: false,
  error: null,
  // Active filter state (kept in Redux so filters survive tab switches)
  filters: {
    dateFrom: '',
    dateTo: '',
    aircraftId: '',
    departureAirportId: '',
    arrivalAirportId: '',
  },
};

// ─── Slice ────────────────────────────────────────────────────────────────────

const revenueSlice = createSlice({
  name: 'revenue',
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearError(state) {
      state.error = null;
    },
    clearReport(state) {
      state.report = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRevenueReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRevenueReport.fulfilled, (state, action) => {
        state.loading = false;
        state.report = action.payload.report || null;
        state.aircraft = action.payload.aircraft || [];
        state.meta = action.payload.meta || null;
      })
      .addCase(fetchRevenueReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to load revenue report';
      });
  },
});

export const { setFilters, clearError, clearReport } = revenueSlice.actions;
export default revenueSlice.reducer;
